import React, { useState } from "react";
import { Modal } from "antd";
import ReduceAction from "../my-carbon-click/reduce/ReduceAction";
import { VIEWED } from "../my-carbon-click/reduce/reduceActionsUtils";
import { bindActionCreators } from "redux";
import * as reduceActionsActions from "../../redux/actions/reduceActionsActions";
import { connect } from "react-redux";

// 
// 

const ReduceActionModal = ({
  title,
  modalOpen,
  modalClose,
  actions,
  currentUserCognito,
  reduceActions,
  preContent,
}) => {
  const [actionsViewedThisSession, setActionsViewedThisSession] = useState([]);

  // 

  const userEngagedWithReduceAction = ({ reduceAction, engagementType }) => {
    let shouldSend = true;

    if (engagementType === VIEWED) {
      if (actionsViewedThisSession.includes(reduceAction.id)) {
        shouldSend = false;
      } else {
        setActionsViewedThisSession([reduceAction.id, ...actionsViewedThisSession])
      }
    }

    if (shouldSend) {
      actions.createReduceActionsUserEngagement({ actionId: reduceAction.id, type: engagementType, email: currentUserCognito?.authData?.email })
    }
  };

  // 

  return (
    <Modal
      width={780}
      centered
      visible={modalOpen}
      footer={false}
      title={false}
      onCancel={modalClose}
    >
      {preContent}

      {title && <p>{title}</p>}

      <div style={{ textAlign: 'left', margin: "24px -24px -24px -24px" }} >
        <ReduceAction
          title="Now take action with these personalised tips:"
          reduceActions={reduceActions?.content}
          onUserEngagedWithReduceAction={userEngagedWithReduceAction}
        />
      </div>
    </Modal>
  )
}

// 

const mapStateToProps = (state) => ({
  currentUserCognito: state.currentUserCognito,
  personalFootprintData: state.personalFootprintData,
  reduceActions: state.reduceActions,
});

// 

const mapDispatchToProps = dispatch => ({
  actions: {
    createReduceActionsUserEngagement: bindActionCreators(
      reduceActionsActions.createReduceActionsUserEngagement,
      dispatch
    ),
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReduceActionModal);
